import {useEffect, useState} from "react";
import HomeRight from "../../assets/images/home_right.png"
import CheckCircleIcon from "../../assets/images/circle-check.png"
import DashedCircleIcon from "../../assets/images/dashed-check.png"
import GreatIcon from "../../assets/images/icon-great.png"
import BadIcon from "../../assets/images/icon-bad.png"
import ArrowDownIcon from "../../assets/images/arrow-down.png"
import * as React from "react";
import {useNavigate} from "react-router-dom";

const HomeStageBadge = ({grade, semester, stageSummary, classInfo}) => {
    const [stageInfo, setStageInfo] = useState(null);
    const [lessonInfo, setLessonInfo] = useState(null);
    const [notStartedStudents, setNotStartedStudents] = useState([]);
    const [completedStudents, setCompletedStudents] = useState([]);
    const [guidanceNeededStudents, setGuidanceNeededStudents] = useState([]);
    const [activeDate, setActiveDate] = useState(null);
    const [showTooltip, setShowTooltip] = React.useState(false); // 툴팁 상태 관리
    const [showTooltipGuidanceNeeded, setShowTooltipGuidanceNeeded] = React.useState(false); // 툴팁 상태 관리
    const navigate = useNavigate();

    const thumbNailDomain = "https://sym008463-sym008463.ktcdn.co.kr/stage_thumbnails/";

    const getThumbnailUrl = (fileName) => {
        return thumbNailDomain+fileName+".png";
    }

    const lessonDetail = () => {
        // setSelectedMenu("class");
        // navigate("/page/classResults/classes/chapter/lesson/stage?classId="+classInfo.classId+"&stageId="+stageInfo.stageId+"&lessonInfoId="+lessonInfo.lessonInfoId);
        navigate("/page/classLessonStage?classId="+classInfo.classId+"&stageId="+stageInfo.stageId+"&lessonInfoId="+lessonInfo.lessonInfoId)
    }



    useEffect(() => {
        if(stageSummary){
            setStageInfo(stageSummary.stageInfo);
            setLessonInfo(stageSummary.lessonInfo);
            setNotStartedStudents(stageSummary.notStartedStudents);
            setCompletedStudents(stageSummary.completedStudents);
            setGuidanceNeededStudents(stageSummary.guidanceNeededStudents);
            setActiveDate(stageSummary.activeDate);
        }
    }, [stageSummary]);


    return (
        <div className="flex flex-col w-full max-w-[1044px] mb-5">
            <div
                className="flex items-center gap-[9px] rounded-t-[20px] border-[1px] border-[#DADADA] bg-white shadow-custom pt-[18px] pb-[15px] px-[21px]">
                <div className="flex justify-center items-center px-[10px] py-[6px] text-[#50555F] text-[12px] text-center font-[700] w-[98px] border-[1px] border-[#D9D9D9] rounded-full">
                    {lessonInfo && lessonInfo.grade}학년 {lessonInfo && lessonInfo.semester}학기
                </div>
                <div className="flex w-full items-center  text-[#50555F] text-[18px] font-[700] max-w-[700px]">
                    {lessonInfo && lessonInfo.lessonTitle}
                </div>
                <div className="flex justify-end w-[100px] px-[10px] text-right text-[#50555F] text-[12px] font-[700]">
                    {activeDate && activeDate}
                </div>
                <div className="flex flex-row justify-center items-center text-[#50555F] text-[16px] font-[800] cursor-pointer"
                    onClick={lessonDetail}
                >
                    상세보기
                    <img
                        src={HomeRight}
                        alt="right"
                        className="ml-1"
                    />
                </div>
            </div>
            <div
                className="flex justify-between items-center rounded-b-[20px] border-[1px] border-[#DADADA] bg-white shadow-custom px-[24px] py-[14px] mt-[-1px]">
                <div className="flex justify-center items-center gap-5">
                    <img
                        className=" w-[178px] h-[108px]"
                        src={stageInfo && getThumbnailUrl(stageInfo.thumbNail)}
                        alt="stage thumbnail"></img>

                    <div className="flex w-full max-w-[450px] items-center ">
                        {stageInfo && stageInfo.stageName}
                    </div>
                </div>
                <div className="inline-flex items-center gap-5">
                    <div
                        className={`flex flex-col w-[61px] gap-[3px] items-center justify-center relative ${notStartedStudents.length > 0 && 'cursor-zoom-in'}`}
                        onMouseEnter={() => notStartedStudents && notStartedStudents.length > 0 && setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                    >
                        <img
                            src={DashedCircleIcon}
                            alt="check-circle"/>
                        <div className="text-[#50555F] text-[16px] font-[700]">미진행</div>
                        <div
                            className="text-[#7494FF] text-[16px] font-[700]">{notStartedStudents && notStartedStudents.length}명
                        </div>
                        {/* 툴팁 표시 */}
                        {showTooltip && notStartedStudents && notStartedStudents.length > 0 && (
                            <>
                                <div
                                    className="absolute mt-[-104px] -translate-y-1/2 left-[50%] transform -translate-x-1/2 bg-black text-white text-xs rounded-md p-2 shadow-lg z-10 max-w-[150px] text-center"
                                >
                                    <div className=" whitespace-nowrap overflow-ellipsis overflow-hidden">
                                        {notStartedStudents.map((student, index) => index < 4 ? (
                                            <div key={index}>{student}</div>) : "")}
                                        {notStartedStudents.length > 4 && "..."}
                                    </div>
                                    <img
                                        src={ArrowDownIcon}
                                        alt="arrow down icon"
                                        className="absolute bottom-[-10px] left-[50%] -translate-x-1/2 w-[8px]"
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    <div className="flex border-[1px] border-[#EAEAEA] h-[82px]"></div>

                    <div className="flex flex-col w-[61px] gap-[3px] items-center justify-center">
                        <img
                            src={CheckCircleIcon}
                            alt="check-circle"/>
                        <div className="text-[#50555F] text-[16px] font-[700]">학습완료</div>
                        <div
                            className="text-[#7494FF] text-[16px] font-[700]">{completedStudents && completedStudents.length}명
                        </div>
                    </div>
                    <div className="flex border-[1px] border-[#EAEAEA] h-[82px]"></div>
                    {completedStudents && completedStudents.length > 0 ? guidanceNeededStudents && guidanceNeededStudents.length > 0 ? (
                        <div
                            className={`flex flex-col w-[61px] gap-[3px] items-center justify-center relative ${guidanceNeededStudents.length > 0 && 'cursor-zoom-in'}`}
                            onMouseEnter={() => guidanceNeededStudents && guidanceNeededStudents.length > 0 && setShowTooltipGuidanceNeeded(true)}
                            onMouseLeave={() => setShowTooltipGuidanceNeeded(false)}>
                            <img
                                src={BadIcon}
                                alt="check-circle"/>
                            <div className="text-[#50555F] text-[16px] font-[700]">어려워요</div>
                            <div
                                className="text-[#FC5955] text-[16px] font-[700]">{guidanceNeededStudents && guidanceNeededStudents.length}명
                            </div>
                            {/* 툴팁 표시 */}
                            {showTooltipGuidanceNeeded && guidanceNeededStudents && guidanceNeededStudents.length > 0 && (
                                <>
                                    <div
                                        className="absolute mt-[-104px] -translate-y-1/2 left-[50%] transform -translate-x-1/2 bg-black text-white text-xs rounded-md p-2 shadow-lg z-10 max-w-[150px] text-center"
                                    >
                                        <div className=" whitespace-nowrap overflow-ellipsis overflow-hidden">
                                            {guidanceNeededStudents.map((student, index) => index < 4 ? (
                                                <div key={index}>{student}</div>) : "")}
                                            {guidanceNeededStudents.length > 4 && "..."}
                                        </div>
                                        <img
                                            src={ArrowDownIcon}
                                            alt="arrow down icon"
                                            className="absolute bottom-[-10px] left-[50%] -translate-x-1/2 w-[8px]"
                                        />
                                    </div>
                                </>
                            )}
                        </div>

                    ) : (
                        <div className="flex flex-col w-[61px] gap-[3px] items-center justify-center">
                            <img
                                src={GreatIcon}
                                alt="check-circle"/>
                            <div className="text-[#50555F] text-[16px] font-[700]">모두</div>
                            <div className="text-[#50555F] text-[16px] font-[700]">잘했어요</div>
                        </div>
                    ) : (
                        <div className="flex flex-col w-[61px] gap-[3px] items-center justify-center">
                            -
                        </div>
                    )}

                </div>
            </div>
        </div>
    )
}


export default HomeStageBadge;